import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Movie } from "./moviesSlice";

interface GptState {
  showGptSearch: boolean;
  movieResults: Movie[][] | null;
  movieNames: string[] | null;
}

const initialState: GptState = {
  showGptSearch: false,
  movieResults: null,
  movieNames: null,
};

const gptSlice = createSlice({
  name: "gpt",
  initialState,
  reducers: {
    toggleGptSearchView: (state) => {
      state.showGptSearch = !state.showGptSearch;
    },
    addGptMovieResults: (state, action: PayloadAction<{ movieNames: string[]; movieResults: Movie[][] }>) => {
      const { movieNames, movieResults } = action.payload;
      state.movieNames = movieNames;
      state.movieResults = movieResults;
    },
  },
});

export const { toggleGptSearchView, addGptMovieResults } = gptSlice.actions;

export default gptSlice.reducer;
